import React from 'react';

export const TableEmptyState = ({ children, className = '' }) => (
    <div className={`table-empty-message${className ? ` ${className}` : ''}`}>
        {children}
    </div>
);
